import DialogLogOut from "@/components/DialogLogOut/dialogLogOut.component";
import { ROUTE_PROFILE } from "@/constants/routes.constants";
import { Button } from "@/shadcn/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { User } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const MainDropdown: React.FC = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  // const { userRole } = useContext(AppContext);

  return (
    <div className="cursor-pointer justify-center">
      <Popover>
        <PopoverTrigger asChild>
          <div className="bg-primary flex h-8 w-8 cursor-pointer items-center justify-center overflow-hidden rounded-full text-white shadow">
            <User />
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-30 p-1" align="start">
          <div className="flex flex-col gap-2">
            {/* {userRole === "approved_user" && ( */}
            <Button
              variant="ghost"
              className="w-full cursor-pointer justify-start !border-none ps-3 focus-visible:!ring-0"
              onClick={() => nav(ROUTE_PROFILE)}
            >
              {t("Profile")}
            </Button>
            {/* )} */}
            <DialogLogOut>
              <Button
                variant="ghost"
                className="w-full cursor-pointer justify-start ps-3 focus-visible:!ring-0"
              >
                {t("Log Out")}
              </Button>
            </DialogLogOut>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default MainDropdown;
